import React, { useMemo } from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { isEmpty, isNil, noop } from 'lodash';
import {
  AssetFVApplicableContextRequest,
  AssetFVApplicableContextResponse,
  getFVApplicableContext,
} from 'services/assetconfig';
import { useQuery } from 'react-query';

export type FVContextUseSelectProps = SelectProps<any> & {
  paramsprops: AssetFVApplicableContextRequest;
  value?: any;
  onSelected?: (context?: AssetFVApplicableContextResponse) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  defaultValue?: any;
};

const FVContextUseSelect = ({
  paramsprops,
  value,
  onChange = noop,
  onSelected,
  allowClear,
  defaultValue,
  ...otherProps
}: FVContextUseSelectProps) => {
  const params: AssetFVApplicableContextRequest = useMemo(
    () => ({
      assetfamily: paramsprops.assetfamily ?? '',
      assettype: paramsprops.assettype ?? '',
      assetcategory: paramsprops?.assetcategory ?? '',
      assetmodel:paramsprops?.assetmodel,
      assetsegment:paramsprops?.assetsegment,
      attributeList:paramsprops?.attributeList,
      catalogid: paramsprops.catalogid ?? ('' as any),
      prcode: paramsprops.prcode ?? '',
      offerid: paramsprops.offerid ?? ('' as any),
      ofrtype: paramsprops.ofrtype ?? '',
      ofrid: paramsprops.ofrid ?? ('' as any),
      duration: paramsprops.duration ?? ('' as any),
      mode: paramsprops.mode ?? 'INIT',
      useCondition: paramsprops.useCondition ?? ([] as any),
    }),
    [paramsprops]
  );

  const { data: Context, isLoading } = useQuery(
    ['getFVApplicableContext', params],
    () =>
      getFVApplicableContext({ request: params }).then((res) => res.list || []),
    { enabled: !isNil(params.prcode) && !isEmpty(params.prcode) }
  );

  const handleChange: SelectProps<number>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected)
      onSelected(Context?.find((ctxt) => ctxt.parcontextid === Number(value)));
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      showSearch
      {...otherProps}
      loading={isLoading}
      allowClear={allowClear}
    >
      {Context?.map((ctxt) => (
        <Select.Option value={ctxt.parcontextid} key={ctxt.parcontextid}>
          {ctxt.contextcodelabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default FVContextUseSelect;
